<div class="manage-admin-users m-auto">
  <section id="addadmin" class="card shadow-sm-darker mb-4">
    <form #addUser="ngForm" name="addUser"
      (ngSubmit)="manageUser(moduleid, schoolid, email.value, modulemanager.ADD_USER)" class="mb-0">
      <h3 class="card-header mb-0" *ngIf="moduleid">Add Tutor</h3>
      <h3 class="card-header mb-0" *ngIf="!moduleid">Add School Administrator</h3>
      <div class="card-body">
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="email">Enter Email <span class="requiredfield">*</span></label>
          <input type="text" class="text-field" ngModel #email name="email" id="email" required>
        </div>
      </div>
      <div class="card-footer">
        <button type="submit" [disabled]="!addUser.form.valid" class="btn">Add User</button>
      </div>
    </form>
  </section>
  <section id="admintutors" class="card shadow-sm-darker m-0">
    <h3 class="card-header mb-0" *ngIf="moduleid">Tutors</h3>
    <h3 class="card-header mb-0" *ngIf="!moduleid">School Administrators</h3>
    <div>
      <app-adminusers *ngIf="tutorList && tutorList.length > 0" [tutorList]="tutorList" [showbuttons]=true (manageuser)="manageuser($event)"></app-adminusers>
      <p *ngIf="!tutorList || tutorList.length === 0" class="text-center text-sm font-italic my-3">No User Has Been Added</p>
    </div>
  </section>
</div>
